import type { FolderState } from '@/user_files/folders/store/slice'

/** Folder ids from root → current (inclusive), using parent_id links in `foldersById`. */
export function getFolderAncestorIds(foldersById: Record<string, FolderState>, folderId: string): string[] {
  const ancestors: string[] = []
  let currentId: string | null = folderId

  while (currentId) {
    const folderState: FolderState | undefined = foldersById[currentId]
    if (!folderState) break
    ancestors.push(currentId)
    currentId = folderState.data.parent_id
  }

  return ancestors.reverse()
}
